import { signal } from '@angular/core';
import { UserProfilePreferences } from './types/user-profile-preferences.types';

export const defaultUserProfilePreferences: UserProfilePreferences = {
    warnAboutUnsavedChanges: true,
    downloadOfflineDataRegularly: true,
};

export const userProfilePreferences = signal<UserProfilePreferences>({
    ...defaultUserProfilePreferences,
});
